import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "live-list",
  name: "直播课程",
  icon: "播",
  group: "国学组件",
  description: "展示直播间、主播和近期课程。",
  defaultProps: {
    "title": "直播课程",
    "limit": 4
}
}
